import { Breadcrumb, Flex, GridAlpha } from '@applyboard/crystal-ui';
import { useAppProcessing } from '~/pages/ApplicationDetails/context';
import { UniqueApplicationsListProvider } from '../context/UniqueApplicationsListProvider';
import { ApplicationDetailsTabs } from '../components/ApplicationDetailsTabs/ApplicationDetailsTabs';
import React from 'react';

import {
  ProgramDetails,
  ApplicationDetailsHeading,
  StatusAndCitizenship,
  ContactInformation,
  ApplicantInformation,
  EducationHistory,
  LanguageProficiency,
  OtherRequiredDocuments,
  ApplicationProcessing,
  CardControlActions,
  DecisionLetters,
  UploadAdditionalDocuments,
  // processing
  AdditionalDocumentNotice,
  DeferralRequestNotice,
  UniqueApplicationsNotice,
  UniqueApplicationsListTable,
} from './../components';
import { AgentInformation } from '../components/Cards/AgentInformation';
import { AlternateProgramInformation } from '../components/Cards/AlternateProgramInformation';
import { BreadcrumbItem } from '~/utils';
import { ApplicationTimeline } from '../components/Cards/ApplicationTimeline';

type MobileLayoutProps = {
  breadcrumbItems: BreadcrumbItem[];
};

export function MobileLayout(props: Readonly<MobileLayoutProps>) {
  const { application } = useAppProcessing();
  const applicationStatus =
    application.status.code === 'DECLINED' ||
    application.status.code === 'INITIAL_OFFER' ||
    application.status.code === 'WAITLISTED' ||
    application.status.code === 'ENROLMENT_CONFIRMED' ||
    application.status.code === 'FINAL_OFFER_ISSUED';
  const shouldRenderAIMLFeature =
    Boolean(application.statusAndCitizenship.documents[0]) &&
    Boolean(application.statusAndCitizenship.documents[0].documentReviewSuggestion);

  const passportId =
    application.statusAndCitizenship.passportId !== undefined
      ? application.statusAndCitizenship.passportId
      : 'NOT_AVAILABLE';
  const currentApplicationId = application.id;

  const listRef = React.useRef<HTMLDivElement>(null);

  function scrollToApplicationsTable() {
    listRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function applicationDetailsLayout() {
    return (
      <GridAlpha columns="minmax(0, 1fr)">
        <Flex gap={8} direction="column">
          <ApplicantInformation />
          <ContactInformation />
          {!shouldRenderAIMLFeature && <StatusAndCitizenship />}
          <EducationHistory />
          <LanguageProficiency />
          <OtherRequiredDocuments />
          <ApplicationTimeline />
          <AlternateProgramInformation />
          <AgentInformation />
          <div ref={listRef}>{passportId !== 'NOT_AVAILABLE' && <UniqueApplicationsListTable />}</div>
        </Flex>
      </GridAlpha>
    );
  }
  return (
    <div aria-label="mobile" style={{ marginBottom: '10px' }}>
      <UniqueApplicationsListProvider passportId={passportId} currentApplicationId={currentApplicationId}>
        <Flex pt={10} pb={2} px={8} gap={6} direction="column">
          <Breadcrumb items={props.breadcrumbItems} />
        </Flex>

        <Flex px={8} gap={6} direction="column">
          <Flex justify="between" align="stretch" direction="column">
            <ApplicationDetailsHeading />
            <ApplicationProcessing />
          </Flex>
          <DeferralRequestNotice />
          <AdditionalDocumentNotice />
          <ProgramDetails lineSplit={true} />
          {passportId !== 'NOT_AVAILABLE' && <UniqueApplicationsNotice onViewTableClick={scrollToApplicationsTable} />}
          <CardControlActions />
          {applicationStatus ? (
            <ApplicationDetailsTabs
              submittedApplicationDetails={applicationDetailsLayout()}
              applicationDetails={
                <Flex gap={8} align="stretch" direction="column">
                  <DecisionLetters />
                  <UploadAdditionalDocuments />
                </Flex>
              }
            />
          ) : (
            applicationDetailsLayout()
          )}
        </Flex>
      </UniqueApplicationsListProvider>
    </div>
  );
}
